import React from 'react';
import PropTypes from 'prop-types';
import {OrderedMap} from 'immutable';
import {history} from 'client/history';
import {Link} from 'react-router';

import classroomV2Store from 'client/Classrooms/Classroom/ClassroomV2.store';

import {Icon, Button, LoadingSpinnerLong} from '@albert-io/atomic';

import StudentInsightTable from './StudentInsightTable.react';
import singleStudentStore from './Student.store';

import './student.scss';

/*
  This component is just a special case of the
  attempt filtered StudentInsightTable.

  The studentInsightTable is connected to a student level insights endpoint
  that spits out information about guesses and questions. We could probably
  just add the ability to filter based on assignment + class in that endpoint
  and then reuse the same response data for this table. Perhaps.
*/

export default class Student extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      classId: PropTypes.string,
      assignmentId: PropTypes.string,
      studentId: PropTypes.string
    })
  };

  getDescription() {
    return (
      <div className='student-insight-description'>
        <strong>{singleStudentStore.getStudentName()}</strong> has answered{' '}
        {`${singleStudentStore.getQuestionsAnswered()} of ${singleStudentStore.getTotalQuestions()}`}{' '}
        questions &nbsp;in <strong>{singleStudentStore.getAssignment().getName()}</strong>.
      </div>
    );
  }

  render() {
    if (
      !singleStudentStore.hasAssignment() ||
      !singleStudentStore.hasStudentStats() ||
      !singleStudentStore.hasGuessInsights()
    ) {
      return (
        <div className='u-display_flex u-align-items_center u-justify-content_center u-pad-tb-5'>
          <LoadingSpinnerLong />
        </div>
      );
    }

    const {classId} = this.props.params;
    const {assignmentId} = this.props.params;

    const insights = singleStudentStore.getStudentLevelGuessInsights();
    const sortedQuestions = singleStudentStore.getAssignment().getSortedQuestions();

    const activeStudentInsights = sortedQuestions.reduce((acc, question) => {
      const questionId = question.getId();
      return acc.set(questionId, insights.get(questionId));
    }, OrderedMap());

    /*
      Passing in our attempt number as ONE, because the assignments
      should only have a single guess against them.

      This is a special hacky use case of the student level insights endpoint
      data. Specifically so we don't have to write an entirely new table
    */

    const nextStudent = classroomV2Store.getNextStudentAlphabetized(this.props.params.studentId);
    return (
      <div className='card max-width'>
        <div className='single-student-view__toolbar'>
          <Button
            color='secondary'
            onClick={() => {
              history.goBack();
            }}
          >
            Back
          </Button>
          <div>
            {nextStudent && (
              <Button
                as={Link}
                size='s'
                color='secondary'
                icon='chevron-right'
                to={`/classes/${classId}/assignments/${assignmentId}/student-detail/${nextStudent.getId()}`}
              >
                Next student <Icon icon='chevron-right' className='u-mar-l_1' />
              </Button>
            )}
          </div>
        </div>
        <div>
          <div className='student-insight-heading'>{singleStudentStore.getStudentName()}</div>
          {this.getDescription()}
        </div>
        <StudentInsightTable
          studentInsights={activeStudentInsights}
          attemptNumber={1}
          showGuess={false}
          transformToCamel
          transformToOneAttempt
        />
      </div>
    );
  }
}
